var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "special-group-card-wrapper d-flex flex-column align-items-center position-relative",
      class: _vm.reverse ? "flex-md-row-reverse" : "flex-md-row",
    },
    [
      _c(
        "div",
        {
          staticClass: "text-box-wrapper flex-grow-1",
          class: _vm.reverse ? "text-box-wrapper-revers" : null,
        },
        [
          _c(
            "div",
            { staticClass: "text-box" },
            [
              _vm.icon && _vm.title
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "title-wrapper d-flex align-items-center",
                      },
                      [
                        _c("img", { attrs: { src: _vm.icon, alt: "icon" } }),
                        _c("p", { staticClass: "text-box-title" }, [
                          _vm._v(" " + _vm._s(_vm.title) + " "),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _c(
                "p",
                { staticClass: "text-box-subtitle font-outfit-semi-bold" },
                [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
              ),
              _c("p", { staticClass: "text-box-description" }, [
                _vm._v(" " + _vm._s(_vm.description) + " "),
              ]),
              _c(
                "div",
                [
                  _c(
                    "ib-button",
                    {
                      attrs: { size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("click")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("getStarted")) + " ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "image-wrapper position-relative" },
        [
          _c("img", {
            staticClass: "img-responsive",
            attrs: { src: _vm.image, alt: _vm.title },
          }),
          _vm._t("card"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }